<template>
	<v-card-text>
		<ChangeAgentDataTable :headers="headers" :items="applicationsData" @showAgent="getApplicationId">
		</ChangeAgentDataTable>
	</v-card-text>

	<!-- Remove the outer dialog -->
	<v-dialog v-model="isDialogOpen" width="400px">
		<v-card rounded="lg">
			<v-card-text style="font-family: 'Roboto'; font-weight: 600">
				<div class="py-2">
				 {{ $t('want_to_change_agent') }}
					<span style="color: rgba(255, 126, 135, 1)">
						{{ assigningAgent }}
					</span>
					?
				</div>
			</v-card-text>
			<v-card-foot class="bg-black">
				<div class="d-flex justify-space-between">
					<v-btn variant="text" @click="isDialogOpen = false" class="text-none">{{ $t('cancel') }}</v-btn>
					<v-btn variant="text" @click="changeAgent">{{ $t('confirm') }}</v-btn>
				</div>
			</v-card-foot>
		</v-card>
	</v-dialog>
</template>

<script>
import ChangeAgentDataTable from './ChangeAgentDataTable.vue'

export default {
	components: {
		ChangeAgentDataTable,
	},
	created() {

	},
	emits: ['closeDialog', 'changeAgent'],
	methods: {
		closeDialog() {
			this.$emit('closeDialog')
		},
		getApplicationId(obj) {
			this.applicationId = obj.id
			this.assigningAgent = obj.firstName
			this.userId = obj.userid
			this.isDialogOpen = true
		},
		changeAgent() {
			this.$emit('changeAgent', {
				applicationId: this.applicationId,
				userId: this.userId,
			})
		},
	},
	props: {
		applicationsData: {
			type: Array,
			required: true,
		},
		incidentId: Number,
	},
	data: () => ({
		application: [],
		applicationId: null,
		assigningAgent: null,
		isDialogOpen: false,
		headers: [
			// {
			// 	text: '',
			// 	value: 'radioSelect',
			// },
			{
				text: 'Agent detail',
				value: 'agentDetial',
			},
			{
				text: 'Skills and certificate',
				value: 'skills',
			},
			{
				text: '',
				value: 'assignButton',
			},
		],
	}),
}
</script>

<style scoped></style>
